export enum LoginProviders {
    Identity = "Identity",
    AzureAD = "AzureAD"
}

export enum SkillTypes {
    WS = "WS",
    ESCO = "ESCO"
}


export enum WSSkillGroups {
    Certification = "Certification",
    HardSkill = "Hard Skill",
    SoftSkill = "Soft Skill"
}